export default "__VITE_ASSET__87dee545__"